import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

type TranslationModule = { default: Record<string, unknown> };
const modules = import.meta.glob<TranslationModule>('./locales/*/*.json', { eager: true });

const resources: Record<string, Record<string, Record<string, unknown>>> = {};
for (const [path, mod] of Object.entries(modules)) {
  const match = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/);
  if (!match) continue;
  const [, lang, ns] = match;
  (resources[lang] ??= {})[ns] = mod.default;
}

export const i18nReady = i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  initImmediate: false,
});

export default i18n;
